var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVimeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25Z",
    fill: "#1AB7EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20.0001L13.5937 21.4063C13.5937 21.4063 15.625 19.6876 16.4062 20.6251C17.0312 21.4063 19.8437 31.4063 20.625 33.2813C21.4062 34.8438 23.5938 37.0313 25.9375 35.4688C28.2813 33.9063 36.0938 27.3438 37.5 19.3751C38.9062 11.5626 28.125 13.1251 27.0312 20.0001C29.6875 18.2813 31.25 20.6251 29.6875 23.4376C28.2812 26.0938 26.875 27.9688 26.25 27.9688C25.625 27.9688 25 26.0938 24.2188 22.9688C23.4375 19.5313 23.4375 13.5938 20 14.3751C16.7188 15.0001 12.5 20.0001 12.5 20.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/Vimeo.b6740d2ed5fce2d8f44a6cba70acbef2.svg";
export { ForwardRef as ReactComponent };